import { render, staticRenderFns } from "./CollectFile.vue?vue&type=template&id=a6bb7638&scoped=true&"
import script from "./CollectFile.vue?vue&type=script&lang=ts&"
export * from "./CollectFile.vue?vue&type=script&lang=ts&"
import style0 from "./CollectFile.vue?vue&type=style&index=0&id=a6bb7638&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6bb7638",
  null
  
)

export default component.exports